// Y axes of the time-series chart: pure helper, no ECharts.
export type AxisSide = 'left' | 'right';
export interface ChartAxis {
  unit: string;
  side: AxisSide;
  /** Position among the axes of the same side (0 = next to the plot). */
  rank: number;
}

export const MAX_AXES = 4;

/**
 * One axis per unit and side. A series without a chosen side follows its unit: the first unit
 * goes left, the next one right, and so on. A series with a chosen side gets the axis of that
 * side, so two signals of the same unit can have separate scales. Past four axes, the
 * remaining series share the last one.
 */
export function layoutAxes(series: Array<{ unit: string; axis?: AxisSide }>): { axes: ChartAxis[]; indexes: number[] } {
  const axes: ChartAxis[] = [];
  const auto = new Map<string, AxisSide>();
  const count = (side: AxisSide) => axes.filter((a) => a.side === side).length;
  const indexes = series.map((s) => {
    let side = s.axis ?? auto.get(s.unit);
    if (!side) {
      side = count('left') <= count('right') ? 'left' : 'right';
      auto.set(s.unit, side);
    }
    const found = axes.findIndex((a) => a.unit === s.unit && a.side === side);
    if (found >= 0) return found;
    if (axes.length >= MAX_AXES) return MAX_AXES - 1;
    axes.push({ unit: s.unit, side, rank: count(side) });
    return axes.length - 1;
  });
  return { axes, indexes };
}
